// URL <-> filter state for the Incomplete Onboarding report (PROD-9198); pure, so it is testable.

import { date_drop_for_report } from '../../../../constants';

// The report opens on today; the select's own blank option normalises back to this.
export const DEFAULT_DATE_FILTER = 'TODAY';

export const MOBILE_VERIFIED_OPTIONS = [
  { value: '1', label: 'Verified' },
  { value: '0', label: 'Not verified' }
];

const VALID_DATE_FILTERS = date_drop_for_report.map((option) => option.value);
const VALID_MOBILE_VERIFIED = MOBILE_VERIFIED_OPTIONS.map((option) => option.value);
const DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

// An unrecognised value in a hand-edited URL falls back to the default instead of reaching the server.
const one_of = (value, allowed, fallback) => (allowed.indexOf(value) === -1 ? fallback : value);

const a_date = (value, fallback) => (DATE_PATTERN.test(value || '') ? value : fallback);

const a_page = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return 1;
  return Math.floor(parsed) < 1 ? 1 : Math.floor(parsed);
};

// `fallback_date` is today, passed in by the caller so this module needs no clock of its own.
export const parse_filters = (search, fallback_date) => {
  const params = new URLSearchParams(search || '');

  return {
    date_filter_type: one_of(params.get('date_filter'), VALID_DATE_FILTERS, DEFAULT_DATE_FILTER),
    start_date: a_date(params.get('start_date'), fallback_date),
    end_date: a_date(params.get('end_date'), fallback_date),
    mobile_verified: one_of(params.get('mobile_verified'), VALID_MOBILE_VERIFIED, ''),
    page: a_page(params.get('page'))
  };
};

// Only what differs from the defaults, so the default first page has no query string.
export const build_search = (filters) => {
  const params = new URLSearchParams();

  if (filters.date_filter_type && filters.date_filter_type !== DEFAULT_DATE_FILTER) {
    params.set('date_filter', filters.date_filter_type);
  }
  if (filters.date_filter_type === 'CUSTOM') {
    if (filters.start_date) params.set('start_date', filters.start_date);
    if (filters.end_date) params.set('end_date', filters.end_date);
  }
  if (filters.mobile_verified) params.set('mobile_verified', filters.mobile_verified);
  if (filters.page > 1) params.set('page', String(filters.page));

  const query = params.toString();
  return query === '' ? '' : `?${query}`;
};
